import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import * as ObjectActions from './root-cause-type.actions';
import { RootCauseTypeCRUDInterface } from '../../../shared/component/filter/filter.class';
import { generateHttpOption } from '../../../shared/helper/app-helper';
import { RootCauseTypeService } from '../../../shared/service/filter/root-cause-type.service';

@Injectable()
export class FilterRootCauseTypeEffects {
  loadFilterRootCauseTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.FilterRootCauseTypeActionType.StartLoadFilterRootCauseTypes),
      switchMap((objectData: ObjectActions.StartLoadFilterRootCauseTypes) => {
        const params = generateHttpOption(objectData.options);
        return from(this.rootCauseTypeService.getData(params)).pipe(
          switchMap((response: RootCauseTypeCRUDInterface[]) => {
            return of(new ObjectActions.FilterRootCauseTypesLoaded(response));
          }),
          catchError(() => {
            return of(new ObjectActions.FilterRootCauseTypesLoaded([]));
          }),
        );
      }),
    ),
  );

  constructor(
    private readonly actions$: Actions<ObjectActions.FilterRootCauseTypeAction>,
    public rootCauseTypeService: RootCauseTypeService,
  ) {}
}
